import script from "./ScrollDown.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollDown.vue?vue&type=script&setup=true&lang=js"

import "./ScrollDown.vue?vue&type=style&index=0&id=f0897160&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0897160"]])

export default __exports__